import React from 'react';
import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.css';
import 'react-file-utils/dist/index.css';

import { ChatView } from '../../utils/chatView';
import {
  ChatContainer,
} from './styles';
import { chatViewConfig } from './config';

const Chat = ({
  chatView,
  isMobileView,
}) => {
  const ChatViewComponent = chatViewConfig[chatView].component;

  return (
    <ChatContainer>
      <ChatViewComponent isMobileView={isMobileView} />
    </ChatContainer>
  );
};

Chat.propTypes = {
  chatView: PropTypes.oneOf(Object.values(ChatView)),
  isMobileView: PropTypes.bool,
};

Chat.defaultProps = {
  chatView: ChatView.WebView,
  isMobileView: false,
};

export default Chat;
